import { Injectable } from '@angular/core';
import { DataCoreService} from '@dabnet-kamu/libs/ui';
import { GenKullaniciService} from '../ctl-gen-kullanici.service';
@Injectable()
export class Service {

    constructor(private dataCoreService: DataCoreService, private service: GenKullaniciService) {}

    getData(control: any) {
            const dataSource = this.dataCoreService.getOData(control.dlistMetadata.baseEntity);

            const filterArr = [];
            if(this.service.isPersonel) filterArr.push(['PersonelKod', '<>', null]);
            if(this.service.isActive) filterArr.push(['AktifEh', '=', 'E']);
            if(filterArr.length > 0) dataSource.filter(filterArr)
            return dataSource;
    }

}
